"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WiFiNetworksFromIwlist = exports.StationMeta = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../schema");
const common_1 = require("./common");
const NAMESPACE = `Network.WiFi.Survey.Iwlist`;
exports.StationMeta = (0, schema_1.CapturePattern)(/^\s*Cell \d* - Address: (?<bssid>(\w|:)*)\s*Channel:(?<channel>\d*)\s*Quality=\d*\/\d* {2}Signal level=(?<rssi>-\d*) dBm$/, effect_1.Schema.Struct({
    bssid: effect_1.Schema.Lowercase,
    channel: effect_1.Schema.NumberFromString,
    rssi: effect_1.Schema.NumberFromString,
}).pipe(effect_1.Schema.compose(common_1.WiFiNetwork))).annotations({
    identifier: `${NAMESPACE}.StationMeta`,
    documentation: "iwlist mlan0 s | grep -i -E 'Cell|Channel:|Quality' | sed 's/dBm/dBm\n/g'",
});
exports.WiFiNetworksFromIwlist = effect_1.Schema.String.pipe(effect_1.Schema.compose(effect_1.Schema.split('\n \n')), // Mind the space between the newlines
effect_1.Schema.compose(effect_1.Schema.Array(exports.StationMeta.pipe(effect_1.Schema.compose(common_1.WiFiNetwork))))).annotations({ identifier: `${NAMESPACE}.WiFiNetworksFromIwlist` });
//# sourceMappingURL=iwlist.js.map